module.exports = __webpack_public_path__ + "img/educacao_empreendedora_prata.80279af9.png";